import { render, staticRenderFns } from "./pile-list.vue?vue&type=template&id=35a10ae6&scoped=true"
import script from "./pile-list.vue?vue&type=script&lang=js"
export * from "./pile-list.vue?vue&type=script&lang=js"
import style0 from "./pile-list.vue?vue&type=style&index=0&id=35a10ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a10ae6",
  null
  
)

export default component.exports